<div *ngIf="!isAvailable">
    <messages name="node-red-unavailable-message"></messages>
</div>
<clx-app-container *ngIf="isAvailable" [config]="config"></clx-app-container>